// removed by extract-text-webpack-plugin
module.exports = {"topWrap":"qempo_InternmentPermitModal_topWrap-3wvXlHF","textWrap":"qempo_InternmentPermitModal_textWrap-2IItcwz","title":"qempo_InternmentPermitModal_title-3rjttyV","contentWrap":"qempo_InternmentPermitModal_contentWrap-uq7XsZY","textContent":"qempo_InternmentPermitModal_textContent-26xSdXh","buttonWrap":"qempo_InternmentPermitModal_buttonWrap-1b9pXGD"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/ProductStep/components/NewProductForm/QuoteBox/InternmentPermitModal/InternmentPermitModal.scss
// module id = 1559
// module chunks = 0